import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  { path: '/login', name: 'login', component: () => import('@/views/Login.vue'), meta: { public: true } },
  {
    path: '/',
    component: () => import('@/views/AppShell.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: { name: 'dashboard' } },
      { path: 'dashboard', name: 'dashboard', component: () => import('@/views/Dashboard.vue') },
      { path: 'kanban', name: 'kanban', component: () => import('@/views/Kanban.vue') },
      { path: 'prioridades', name: 'prioridades', component: () => import('@/views/Prioridades.vue') },
      { path: 'itens', name: 'itens', component: () => import('@/views/ItensList.vue') },
      { path: 'itens/novo', name: 'item-novo', component: () => import('@/views/ItemEditor.vue'), props: { mode: 'create' } },
      { path: 'itens/:id', name: 'item-detail', component: () => import('@/views/ItemDetail.vue'), props: true },
      { path: 'ondas', name: 'ondas', component: () => import('@/views/Ondas.vue') },
      { path: 'replanejamento', name: 'replanejamento', component: () => import('@/views/Replanejamento.vue') },
      { path: 'apresentacao', name: 'apresentacao', component: () => import('@/views/Apresentacao.vue') },
      { path: 'ondas/:ondaId', name: 'onda-detalhe', component: () => import('@/views/OndaDetalhe.vue'), props: true },
      { path: 'sprints/:id', name: 'sprint-detalhe', component: () => import('@/views/SprintDetalhe.vue'), props: true },
      { path: 'admin/usuarios', name: 'admin-usuarios', component: () => import('@/views/admin/Usuarios.vue'), meta: { roles: ['admin'] } },
      { path: 'admin/areas', name: 'admin-areas', component: () => import('@/views/admin/Areas.vue'), meta: { roles: ['admin'] } },
      { path: 'admin/status', name: 'admin-status', component: () => import('@/views/admin/StatusAdmin.vue'), meta: { roles: ['admin'] } },
      { path: 'perfil', name: 'perfil', component: () => import('@/views/Perfil.vue') },
    ]
  },
  { path: '/:catchAll(.*)*', redirect: { name: 'dashboard' } }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!auth.initialized) {
    await auth.fetchMe()
  }
  if (to.meta.public) {
    if (auth.isAuthenticated && to.name === 'login') return { name: 'dashboard' }
    return true
  }
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  const requiredRoles = (to.meta.roles as string[] | undefined)
  if (requiredRoles && requiredRoles.length > 0 && !requiredRoles.includes(auth.role ?? '')) {
    return { name: 'dashboard' }
  }
  return true
})

export default router
